export default function(bienData = {} , action) {
    
    if(action.type === "addBienData"){
        var newBienData = action.thisData      
        return newBienData
    } else {
        return bienData
    }
}